import { merge } from 'lodash';

const defaultMotletState = () => ({
  id: '',
  title: '',
  monitor: {
    systemId: '',
    monitorCode: '',
    eventCode: '',
    categoryField: '',
    valueField: '',
  },
  descendants: [],
  descendant: {
    systemId: '',
    id: '',
  },
  zoom: {
    use: false,
    active: false,
    restore: false,
  },
  settings: {
    chart: {
      use: false,
      field: {
        code: '',
        text: '',
      },
    },
    grid: {
      use: false,
      code: '',
      selectedFields: [],
    },
  },
  taskType: {
    use: false,
    selected: null,
    divider: false,
  },
  loadKind: {
    use: false,
    selected: null,
    divider: false,
  },
  logonType: {
    use: false,
    selected: null,
    divider: false,
  },
  yAxisMax: {
    use: false,
    value: 0,
    divider: false,
  },
  abapDumpTerm: {
    use: false,
    value: 0,
    divider: false,
  },
  updRecTerm: {
    use: false,
    value: 0,
    divider: false,
  },
  xAxisPoints: {
    use: false,
    value: 0,
    divider: false,
  },
  dataParam: {},
});

const state = {
  motlet: {},
};

const getters = {};

const mutations = {
  setMotlet(state, options) {
    const targetMotletState = state[options.id] || {};
    state.motlet = merge({}, state.motlet, {
      [options.id]: merge(defaultMotletState(), targetMotletState, options),
    });
  },
  resetMotlet(state, options) {
    delete state.motlet[options.id];
  },
  setZoomActive(state, param) {
    state.motlet[param.id].zoom.active = param.active;
  },
  setZoomRestore(state, param) {
    state.motlet[param.id].zoom.restore = param.restore;
  },
  setChartField(state, param) {
    state.motlet[param.id].settings.chart.field = param.field;
  },
  setGridSelectedFields(state, param) {
    state.motlet[param.id].settings.grid.selectedFields = param.fields;
  },
  setMonitor(state, param) {
    state.motlet[param.id].monitor = merge({}, state.motlet[param.id].monitor, param.monitor);
  },
  setDescendant(state, param) {
    state.motlet[param.id].descendant = merge({}, state.motlet[param.id].descendant, param.descendant);
  },
  setDescendants(state, param) {
    state.motlet[param.id].descendants = param.descendants;
  },
  setCycle(state, param) {
    state.motlet[param.id].monitor.cycle = param.cycle;
  },
  setTaskType(state, param) {
    state.motlet[param.id].taskType.selected = param.taskType;
  },
  // BEGIN::Added.by.KWShin.2024.01.12.
  setLoadKind(state, param) {
    state.motlet[param.id].loadKind.selected = param.loadKind;
  },
  // FINISH::Added.by.KWShin.2024.01.12.
  // BEGIN::Added.by.KWShin.2024.01.14.
  setLogonType(state, param) {
    state.motlet[param.id].logonType.selected = param.logonType;
  },
  // FINISH::Added.by.KWShin.2024.01.14.
  // BEGIN::Added.by.KWShin.2024.01.26.
  setYAxisMax(state, param) {
    state.motlet[param.id].yAxisMax.value = param.yAxisMax;
  },
  // FINISH::Added.by.KWShin.2024.01.26.
  // BEGIN::Added.by.KWShin.2024.01.29.
  setAbapDumpTerm(state, param) {
    state.motlet[param.id].abapDumpTerm.value = param.abapDumpTerm;
  },
  setUpdRecTerm(state, param) {
    state.motlet[param.id].updRecTerm.value = param.updRecTerm;
  },
  // FINISH::Added.by.KWShin.2024.01.29.
  // BEGIN::Added.by.KWShin.2024.03.06.
  setXAxisPoints(state, param) {
    state.motlet[param.id].xAxisPoints.value = param.xAxisPoints;
  },
  // FINISH::Added.by.KWShin.2024.03.06.
};

const actions = {
  setMotlet({ commit }, options) {
    commit('setMotlet', options);
  },
  resetMotlet({ commit }, options) {
    commit('setMotlet', options);
  },
  setZoomActive({ commit }, param) {
    commit('setZoomActive', param);
  },
  setZoomRestore({ commit }, param) {
    commit('setZoomRestore', param);
  },
  setChartField({ commit }, param) {
    commit('setChartField', param);
  },
  setGridSelectedFields({ commit }, param) {
    commit('setGridSelectedFields', param);
  },
  setMonitor({ commit }, param) {
    commit('setMonitor', param);
  },
  setDescendants({ commit }, param) {
    commit('setDescendants', param);
  },
  setDescendant({ commit }, param) {
    commit('setDescendant', param);
  },
  setCycle({ commit }, param) {
    commit('setCycle', param);
  },
  setTaskType({ commit }, param) {
    commit('setTaskType', param);
  },
  // BEGIN::Added.by.KWShin.2024.01.12.
  setLoadKind({ commit }, param) {
    commit('setLoadKind', param);
  },
  // FINISH::Added.by.KWShin.2024.01.12.
  // BEGIN::Added.by.KWShin.2024.01.14.
  setLogonType({ commit }, param) {
    commit('setLogonType', param);
  },
  // FINISH::Added.by.KWShin.2024.01.14.
  // BEGIN::Added.by.KWShin.2024.01.26.
  setYAxisMax({ commit }, param) {
    commit('setYAxisMax', param);
  },
  // FINISH::Added.by.KWShin.2024.01.26.
  // BEGIN::Added.by.KWShin.2024.01.29.
  setAbapDumpTerm({ commit }, param) {
    commit('setAbapDumpTerm', param);
  },
  setUpdRecTerm({ commit }, param) {
    commit('setUpdRecTerm', param);
  },
  // FINISH::Added.by.KWShin.2024.01.29.
  // BEGIN::Added.by.KWShin.2024.03.06.
  setXAxisPoints({ commit }, param) {
    commit('setXAxisPoints', param);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
